import React, { memo, useState } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Space,
  IconExit,
  Text,
  Divider,
  LoadingContainer,
  IconChangePassword,
} from '@redlink/components/atoms';
import { PurchaseButton } from '@redlink/components/muscles';
import { IconButtonItem, useTooltip } from '@redlink/components/molecules';
import { PageCompactList } from '@redlink/components/organisms';
import { useValues } from '@redlink/assets/values';
import {
  useQuery,
  getUserProfileQuery,
  getPageProfileQuery,
} from '@redlink/services';
import { useLocale } from '@redlink/assets/locale';

export const HeaderTooltipTemplate = memo(
  ({
    navigation,
    workspace = false,
    onPlanPress,
    onPasswordManagementPress,
  }) => {
    const { styles, colors } = useStyle();
    const { routes } = useValues();
    const { dictionary } = useLocale();
    const [isChangingPage, setIsChangingPage] = useState(false);
    const { dismissTooltip } = useTooltip();

    const {
      data: { UserProfile: { username } = {} },
    } = useQuery(getUserProfileQuery);

    const {
      data: {
        PageProfile: {
          pageName,
          isDefault,
          currentPlan: { expireDays, isProUser } = {},
        } = {},
      },
    } = useQuery(getPageProfileQuery);

    return (
      <LoadingContainer isBusy={isChangingPage} style={styles.container}>
        <Space size={8} />
        <Text style={styles.usernameText}>{username}</Text>

        {!workspace && (
          <>
            <Space />
            <PurchaseButton
              {...{ isProUser, expireDays }}
              onPress={() => {
                dismissTooltip();
                onPlanPress();
              }}
            />
          </>
        )}
        <Space size={8} />
        <View style={styles.bodyContainer}>
          {/* {workspace && (
            <>
              <IconButtonItem
                title={dictionary.passwordManagement}
                onPress={() => {
                  dismissTooltip();
                  onPasswordManagementPress();
                }}
              >
                <IconChangePassword color={colors.black} size={24} />
              </IconButtonItem>
              <Space size={8} />
            </>
          )} */}
          <IconButtonItem
            title={dictionary.signOut}
            onPress={() => {
              dismissTooltip();
              navigation.navigate(routes.signOut.key);
            }}
          >
            <IconExit color={colors.black} size={24} />
          </IconButtonItem>
          {!workspace && (
            <>
              <Divider margin={8} />
              <PageCompactList
                currentPageName={pageName}
                onAddPress={() => {
                  dismissTooltip();
                  navigation.navigate(routes.pages.key);
                }}
                onSelect={({ id }) => {
                  setIsChangingPage(true);
                }}
              />
            </>
          )}
        </View>
      </LoadingContainer>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow, theme }) => ({
  signOutButton: {
    width: 48,
    height: 48,
  },
  container: {
    minWidth: 244,
  },
  usernameText: {
    fontSize: 12,
    color: colors.gray21,
    textAlign: 'center',
  },
  bodyContainer: {
    paddingHorizontal: 8,
  },
}));
